import { useGetPaymentMethodsQuery } from '@/affiliate-dashboard/graphql';
import { Loading } from '@/components/base/loading';
import invariant from 'tiny-invariant';
import { BalanceCard } from './balance-card';
import { PaymentMethods } from './payment-methods';
import { PayoutHistoryWithData } from './payout-history';

export function Wallet(): JSX.Element {
  const { data, loading } = useGetPaymentMethodsQuery();

  if (loading) {
    return <Loading />;
  }
  invariant(data, 'No payment method found');
  const currentMethod = data?.paymentMethods?.at(-1);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex w-full flex-col gap-6 md:flex-row">
        <BalanceCard methodExists={Boolean(currentMethod)} />
        {currentMethod && <PaymentMethods currentMethod={currentMethod} />}
      </div>
      <div className="col-span-2 flex w-full flex-col gap-7">
        <PayoutHistoryWithData />
      </div>
    </div>
  );
}
